import { findIndex } from 'lodash'

export default class Middleware {

  constructor(middleware = {}) {
    this.id = middleware.id || null
    this.name = middleware.name || ''
    this.type = middleware.type || {}
    this.middleware_type_id = middleware.middleware_type_id || null
    this.environment_id = middleware.middleware_type_id || null
    this.class = middleware.class || ''
    this.class_name = middleware.class_name || ''
    this.bindings = middleware.bindings || []
  }

  static mutations() {
    return {
      setMiddleware: (state, middleware) => state.middleware = new Middleware(middleware),
      setBindings: (state, bindings) => {
        bindings.forEach(binding => {
          state.middleware.bindings.push(binding)
        });
      },
      removeBinding: (state, modelId) => {
        let index = findIndex(state.middleware.bindings, binding => binding.id === modelId)
        state.middleware.bindings.splice(index, 1)
      },
      setType: (state, payload) => state.middleware.type = payload
    }
  }
}  